import { render, staticRenderFns } from "./UserAdd.vue?vue&type=template&id=35150ff8&scoped=true&"
import script from "./UserAdd.vue?vue&type=script&lang=js&"
export * from "./UserAdd.vue?vue&type=script&lang=js&"
import style0 from "./UserAdd.vue?vue&type=style&index=0&id=35150ff8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35150ff8",
  null
  
)

export default component.exports